import { EntTypesOfCompany, EntTypesOfFertilizers } from '../handBooks/typesOfFertilizers'

export class EntStock {
	id: number | null = null
	warehouseId: number | null = null
	warehouseName: string | null = null
	fertilizer: EntTypesOfFertilizers | null = null
	company: EntTypesOfCompany | null = null
	pricePerKg: number | null = null
	availableQuantity: number | null = null
	distributedQuantity: number | null = null
	totalQuantity: number | null = null
	reportingYear: number | null = null
	fertilizerId?: number | null = null
	companyId?: number | null = null
}
